import { render } from "./AnswersTable.vue?vue&type=template&id=1833cdb5"
import script from "./AnswersTable.vue?vue&type=script&lang=js"
export * from "./AnswersTable.vue?vue&type=script&lang=js"

import exportComponent from "/home/nathan/public_html/accident-plan/accident-plan-api-whitelabel/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__